(function () {
    'use strict';

    /* controller for first free appointments list view */
    var module = angular.module('uwAgenda.agenda');
    module.controller('AgendaFirstFreeAppointmentController', [
        '$scope', 
        '$rootScope', 
        'Weekday', 
        'Alert', 
        'SharedAgendaService', 
        'AgendaService', 
        'HelperService', 
        'agendaLabels', 
        'AgendaFilterBroadcast', 
        'AgendaOverviewService', 
        'PaginationService', 
        'DateService',
        'WebsocketRegisterType',
        'WebsocketService',
        AgendaFirstFreeAppointmentControllerFn]);

    function AgendaFirstFreeAppointmentControllerFn(
        $scope,
        $rootScope, 
        Weekday, 
        Alert, 
        SharedAgendaService, 
        AgendaService, 
        HelperService, 
        agendaLabels, 
        AgendaFilterBroadcast, 
        AgendaOverviewService, 
        PaginationService, 
        DateService,
        WebsocketRegisterType,
        WebsocketService
    ) {
        /* jshint validthis:true */
        var vm = this;
        vm.overview = null;
        // filter options
        vm.sharedAgendas = [];
        vm.agendaLabels = [];
        vm.weekdays = [];
        vm.dateFrom = null;


        // from-hours
        vm.fromHours = null;
        var fromTime = null;
        // to-hours
        vm.toHours = null;
        var toTime = null;


        /* clear filter */
        vm.clear = clear;

        /* load free appointments with filter */
        vm.refresh = refresh;
        
        // load labels
        vm.loadLabels = LoadLabels;

        /* load more items and append to existing list */
        vm.loadMore = function (agendaId) {
            refresh(agendaId, true, true);
        };

        activate();

        // activation work
        function activate() {
            // set to empty array, because data is loaded dynamically
            vm.overview = new PaginationService([]);

            // allow shared agenda-switch
            SharedAgendaService.allow();

            // load shared-agendas filter data - only add agendas that have the share first free appointment flag set
            vm.sharedAgendas = SharedAgendaService.getAgendasShownInFreeAppointments();
            
            // number of agendas to show
            AgendaOverviewService.data.numberOfAgendas = vm.sharedAgendas.length;

            // load weekdays filter data
            vm.weekdays.push({ value: Weekday.Monday.value, name: Weekday.Monday.name, vmSelected: false });
            vm.weekdays.push({ value: Weekday.Tuesday.value, name: Weekday.Tuesday.name, vmSelected: false });
            vm.weekdays.push({ value: Weekday.Wednesday.value, name: Weekday.Wednesday.name, vmSelected: false });
            vm.weekdays.push({ value: Weekday.Thursday.value, name: Weekday.Thursday.name, vmSelected: false });
            vm.weekdays.push({ value: Weekday.Friday.value, name: Weekday.Friday.name, vmSelected: false });
            vm.weekdays.push({ value: Weekday.Saturday.value, name: Weekday.Saturday.name, vmSelected: false });
            vm.weekdays.push({ value: Weekday.Sunday.value, name: Weekday.Sunday.name, vmSelected: false });

            // set filters to default state
            clear(true); // load filter from localstorage

            // load labels
            LoadLabels();
            
            // load the data if at least one agenda has been selected            
            for (let i = 0; i < vm.sharedAgendas.length; i++) {
                if (vm.sharedAgendas[i].vmSelected) {
                    refresh();
                    break;
                }
            } // for


            // listen
            listen();

        } // activate

        // listen
        function listen() {
            let listener = $scope.$on(AgendaFilterBroadcast.ListRefresh, function (event, agendaId) {
                // refresh
                refresh(agendaId, false);
            });
            // Websocket Listen
            const ws = WebsocketService.register(
                WebsocketRegisterType.Agenda,
                function (obj) {
                    const agendaId = obj.data.fK_Agenda;
                    for (let i = 0; i < vm.sharedAgendas.length; i++) {
                        if (vm.sharedAgendas[i].vmSelected && vm.sharedAgendas[i].id === agendaId) {
                            refresh();
                            break;
                        }
                    }
                }
            );
            $scope.$on("$destroy", function () {
                listener();
                listener = null;
                AgendaOverviewService.data.numberOfAgendas = 0;
                if (ws) {
                    WebsocketService.unregister(ws.id);
                }
            });
        }
        
        // reload labels according to selected agendas
        function LoadLabels(){
            // load agenda-labels filter data
            vm.agendaLabels = [];

            for (let i = 0; i < vm.sharedAgendas.length; i++) {
                let visibleAgenda = vm.sharedAgendas[i];

                // add only agenda labels for selected agendas
                if (visibleAgenda.vmSelected)
                {
                    for (var j = 0; j < agendaLabels.length; j++) {
                        if (agendaLabels[j].fK_Agenda === visibleAgenda.id) {
                            vm.agendaLabels.push(agendaLabels[j]);
                        }
                    }
                }
            }
            $rootScope.$broadcast(AgendaFilterBroadcast.AgendaLabelRefresh);
            $rootScope.$broadcast(AgendaFilterBroadcast.AgendaLabelClear);
        }

        // reload data
        function refresh(agendaId, appendToExistingList, loadMore) {
            HelperService.block("#firstFree");
            if (appendToExistingList === undefined || appendToExistingList === null) { appendToExistingList = false; }

            // get selected agenda ids
            var selectedAgendaIds = [];
            // load-more can only be used for one agenda per search
            if (agendaId > 0) {
                selectedAgendaIds.push(agendaId);
            }
            else {
                // clear data to force view update
                vm.overview.init([]);

                for (var i = 0; i < vm.sharedAgendas.length; i++) {
                    if (vm.sharedAgendas[i].vmSelected === true) {
                        selectedAgendaIds.push(vm.sharedAgendas[i].id);
                    }
                }
            }

            // check if at least one agenda is selected
            if (selectedAgendaIds.length === 0) {
                HelperService.unblock("#firstFree");
                Alert.danger('At least one agenda has to be selected!');
                return;
            }

            // get selected agendalabel ids
            var selectedAgendaLabelIds = [];
            for (var j = 0; j < vm.agendaLabels.length; j++) {
                if (vm.agendaLabels[j].vmSelected === true) {
                    selectedAgendaLabelIds.push(vm.agendaLabels[j].id);
                }
            }

            // get selected weekdays
            var selectedWeekdays = [];
            for (var k = 0; k < vm.weekdays.length; k++) {
                if (vm.weekdays[k].vmSelected === true) {
                    selectedWeekdays.push(vm.weekdays[k].value);
                }
            }

            var startDate = vm.dateFrom;
            // if more free appointments should be searched, use the last search-enddate as the new search date
            if (agendaId > 0) {
                for (var l = 0; l < vm.overview.data.items.length; l++) {
                    // get the date for the selected user
                    if (vm.overview.data.items[l].agendaOwner.agendaId === agendaId) {
                        const dateStr = vm.overview.data.items[l].newSearchDate;
                        const date = new Date(dateStr);
                        date.setTime(date.getTime() + 60000); // add a minute so it doesn't find the last one again 
                        startDate = date.toISOString();
                        break;
                    }
                }
            }

            // time (hours)
            fromTime = null;
            if (vm.fromHours) {
                fromTime = moment();
                fromTime.utcOffset(0);
                fromTime.hour(vm.fromHours);
                fromTime.minute(0);
            }
            toTime = null;
            if (vm.toHours) {
                toTime = moment();
                toTime.utcOffset(0);
                toTime.hour(vm.toHours);
                toTime.minute(0);
            }

            var fd = HelperService.isoDateWithoutZoneFromMoment(fromTime);
            var td = HelperService.isoDateWithoutZoneFromMoment(toTime);


            // call api to get appointments
            AgendaService.firstFreeAppointments(selectedAgendaIds, selectedAgendaLabelIds, selectedWeekdays, startDate, fd, td, loadMore).then(function (items) {
                HelperService.unblock("#firstFree");
                setFilteredData(items, appendToExistingList);
            }, function (error) {
                HelperService.unblock("#firstFree");
                Alert.error(error);
            });
        }

        // clear filter and set default-states again
        function clear(loadFromLocalStorage) {
            // set selected calendardate as startdate for search
            vm.dateFrom = DateService.data.date;
            fromTime = null;
            toTime = null;
            vm.fromHours = null;
            vm.toHours = null;

            var i = 0;
            var j = 0;
            var k = 0;

            // reset selected agendas
            for (i = 0; i < vm.sharedAgendas.length; i++) {
                vm.sharedAgendas[i].vmSelected = true;
            }

            // reset agenda labels
            for (j = 0; j < vm.agendaLabels.length; j++) {
                vm.agendaLabels[j].vmSelected = false;
            }

            // reset weekdays
            for (k = 0; k < vm.weekdays.length; k++) {
                vm.weekdays[k].vmSelected = false;
            }

            // inform listener
            $rootScope.$broadcast(AgendaFilterBroadcast.AgendaLabelRefresh);
            $rootScope.$broadcast(AgendaFilterBroadcast.AgendaLabelClear);
            $rootScope.$broadcast(AgendaFilterBroadcast.WeekdayRefresh);
            $rootScope.$broadcast(AgendaFilterBroadcast.WeekdayClear);
            $rootScope.$broadcast(AgendaFilterBroadcast.SharedAgendaRefresh);
        }

        // add the agenda to each first free appointment label
        function addAgendaToAppointmentLabels(items) {
            items.forEach(data => {
                const agenda = SharedAgendaService.getAgenda(data.agendaOwner.agendaId);
                for(const date in data.appointmentsPerDay) {
                    if (data.appointmentsPerDay.hasOwnProperty(date)) {
                        data.appointmentsPerDay[date].forEach(appointment => {
                            appointment.agenda = agenda;
                        });
                    }
                }
            })
        }

        // update filter-strings and datalist
        function setFilteredData(items, appendToExistingList) {
            addAgendaToAppointmentLabels(items);
            var i = 0;
            var j = 0;

            // set data - if new items should be appended, combine the existing list with the new one
            if (appendToExistingList && vm.overview.data.items) {
                for (i = 0; i < items.length; i++) {
                    var newItem = items[i];
                    for (j = 0; j < vm.overview.data.items.length; j++) {
                        var existingItem = vm.overview.data.items[j];
                        // make sure items get added to correct agenda
                        if (newItem.agendaOwner.id === existingItem.agendaOwner.id) {
                            // update item count & searchdate
                            existingItem.appointmentCount += newItem.appointmentCount;
                            existingItem.newSearchDate = newItem.newSearchDate;

                            // appointmentsPerDay is an object of key-value pairs, so we use this workaround to add the new time-items to the list
                            var appointmentsPerDay = newItem.appointmentsPerDay;
                            for (var date in appointmentsPerDay) {
                                if (appointmentsPerDay.hasOwnProperty(date)) {
                                    existingItem.appointmentsPerDay[date] = appointmentsPerDay[date];
                                } //if
                            } // for
                            break;
                        }
                    }
                }

                // reload data to update indexes
                vm.overview.init(vm.overview.data.items);
            }
            else {
                vm.overview.init(items);
            }

            // inform listener
            $rootScope.$broadcast(AgendaFilterBroadcast.AgendaLabelCalculate);
            $rootScope.$broadcast(AgendaFilterBroadcast.WeekdayCalculate);

        }
    }
})();
